<template>
    <div class="commentList">
        <div class="commentItem marginT24" v-for="dataItem in dataList" :key="dataItem.id" :data-id="dataItem.id">
            <div class="flexLayout" style="line-height: 36px;">
                <div style="width: 24px;">
                    <img style="vertical-align: text-bottom;" width="24" height="24" :src="dataItem.headerImg" class="size24 circle"/>
                </div>
                <div style=" ;" class="flexItem paddingH8 font14r grey20">
                    {{dataItem.userName}}
                </div>
                <div class="grey60 font10r" style="width: 45px;">
                    {{formatDate(dataItem.createTime)}}
                </div>
            </div>
            <div class="marginT12 font13r" style="
                line-height: 1.692em;
                color: #2C2C2C;
                font-size: 14px;
                font-weight: 400;
                margin-left:32px;
                ">
                {{dataItem.content}}
            </div>
            <div class="replyContentContainer relative" v-if="dataItem.replyContext"
                 style="margin-left:32px; margin-top: 12px;"
                 :data-replyTime="formatDate(dataItem.replyTime)" :data-replyUserName="dataItem.replyUserName">
                <div class="inner lineHeight150p font12r">作者：{{dataItem.replyContext}}</div>
            </div>
        </div>
        <div class="paddingV12 alignC font14r" v-if="status === 'ready' && dataList.length < 1">
            暂无任何评论
        </div>
    </div>
</template>

<script>
import generalCmpPart   from "@/components/part/generalCmpPart";

// config
import appConfig        from '@/appConfig';

// utils
import objectHelper     from '@/util/objectHelper';
import arrayHelper      from '@/util/arrayHelper';
import appHelper        from '@/util/appHelper';
import moment           from 'moment';
import dataMixedUtils from "@util/dataMixedUtils";

const config = {
    apiConfig : {
        list : {
            url : 'portal/message/getCommentList',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoContentList : [
        '好东西！',
        '太赞了！',
        '爱了！爱了！'
    ]
};

export default {
    extends : generalCmpPart,
    components : {  },
    data () {
        return {
            apiConfig : config.apiConfig,
            // pageSize : 8,
            enableDataList : true,
            // autoLoadData : appConfig.mode != 'demo'
        }
    },
    methods : {
        formatDate(timestamp) {
            return moment(timestamp).format('MM-DD')
        },
        loadComment(options = {}){
            this.apiConfig.list.params = options;
            this.reloadDataList();
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {
                return {
                    id : index,
                    createTime : new Date().getTime() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 7),
                    headerImg : appHelper.getRandomUserHead(),
                    userName : dataMixedUtils.string.getRandomNickName(),
                    content : arrayHelper.getRandomItem(config.demoContentList),
                    replyContext : ''
                }
            });
            return;
        }
    }
}
</script>

<style lang="scss" scoped>
.replyContentContainer {
    border-radius: 4px;
    background: #F8F8F6;
    color: #939191;
    &:before {
        content: '';
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        margin-top: -16px;
        margin-left: 16px;
        border-style: solid;
        border-color: transparent transparent #F8F8F6;
        border-width: 8px 5px;
    }
    .inner {
        padding: 8px 12px;
    }
}
</style>
